import { makeStyles, styled } from '@material-ui/styles'
import React from 'react'
import Checkbox from 'core/elements/input/Checkbox'
import Menu from 'core/elements/menu/Menu'
import Text from 'core/elements/Text'
import useToggler from 'core/hooks/useToggler'
import Theme from 'core/themes/model'
import FontAwesomeIcon from '../../components/FontAwesomeIcon'
import { GridManagedColumnsProps } from './hooks/useGridManagedColumns'

const menuOffset = {
  vertical: 0,
  horizontal: -100,
}

const GridColumnsButton = styled(({ className, onClick, iconOnly }) => (
  <Text onClick={onClick} component="div" className={className}>
    <FontAwesomeIcon>gear</FontAwesomeIcon>
    {!iconOnly && 'Manage Columns'}
  </Text>
))<Theme>(({ theme }) => ({
  ...theme.typography.inputTable,
  display: 'grid',
  gridAutoFlow: 'column',
  cursor: 'pointer',
  alignItems: 'center',
  padding: theme.spacing(2, 1),
  borderRadius: 4,
  border: `1px solid ${theme.components.table.border}`,
  gap: 8,
  '&:hover': {
    backgroundColor: theme.components.table.hoverBackground,
  },
}))

interface GridColumnsPopoverProps extends GridManagedColumnsProps {
  isOpen?: boolean
  onToggle?: () => void
  iconOnly?: boolean
}

export default function GridColumnsPopover({
  columnTogglers,
  isOpen: externalIsOpen,
  onToggle: externalOnToggle,
  iconOnly = false,
}: GridColumnsPopoverProps) {
  const classes = useStyles()
  const [internalIsOpen, toggleInternalIsOpen] = useToggler()

  const isOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen
  const toggleIsOpen = externalOnToggle || toggleInternalIsOpen

  return (
    <Menu
      id="grid-columns-menu"
      origin="top right"
      offset={menuOffset}
      className={classes.menu}
      anchor={<GridColumnsButton iconOnly={iconOnly} onClick={toggleIsOpen} />}
      open={isOpen}
      onClose={toggleIsOpen}
    >
      {columnTogglers.map(({ key, label, visible, disabled, toggleColumn }) => (
        <Checkbox
          key={key}
          label={label}
          disabled={disabled}
          checked={visible}
          onChange={toggleColumn}
        />
      ))}
    </Menu>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  menu: {
    '& .menu-popover': {
      minWidth: 150,
      padding: '8px',
    },
  },
}))
